module.exports = __webpack_public_path__ + "img/fw.442bbddf.png";